/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./search-bar.vue?vue&type=template&id=cdd12fc8&scoped=true&"
import script from "./search-bar.vue?vue&type=script&lang=ts&"
export * from "./search-bar.vue?vue&type=script&lang=ts&"
import style0 from "./search-bar.vue?vue&type=style&index=0&id=cdd12fc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd12fc8",
  null
  
)

export default component.exports